module.exports = __webpack_public_path__ + "img/file-----------------@1x.743027ef.png";